import React from "react";
import { FaHatCowboy, FaChalkboardTeacher } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";
import { motion as m } from "framer-motion";
import { Helmet } from "react-helmet";
import Card from 'react-bootstrap/Card';

const FacultyManagementSciences = () => {
    return (
        <m.div
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            exit={{ scaleY: 0 }}
            transition={{ duration: 0.5 }}
        >
            <>
                <Helmet>
                    <title>Faculty of Management Sciences |</title>
                </Helmet>
                {/* <Navcomponent /> */}
                <section id="courses" className="border-green">
                    <div className="course-mainheading">
                        <h1 className="font-tomatosemibold text-orange text-center"><FaChalkboardTeacher />  FACULTY</h1>
                    </div>
                </section>
                <section id="faculty">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            <div className="faculty-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/sadaqathussain.jpg'} alt="course" />
                                            </div>
                                            <div className="course-pill">
                                                <FaHatCowboy />  Professor
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">Dr. Sayyed Sadaqat Hussain Shah</Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                                <h3>Qualification </h3>
                                                <p><b>PhD Management</b><br />
                                                    Huazhong University of Science and Technology, HUST, PR China</p>
                                                <h4>Areas of Interest:</h4>
                                                Behavioral Finance<br />
                                                Educational Policy Analysis<br />
                                                Pedagogical Research<br />
                                                Curriculum Development
                                            </Card.Text>
                                            <div className="book float-right">
                                                <GiTeacher />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            <div className="faculty-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/Drfaizanmalik.jpeg'} alt="course" />
                                            </div>
                                            <div className="course-pill">
                                                <FaHatCowboy />  Associate Professor
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">Dr. Muhammad Faizan Malik</Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                                <h3>Qualification </h3>
                                                <p><b>PhD</b><br />
                                                    Azman Hashim International Business School, Universiti Teknologi Malaysia</p>
                                                <h4>Areas of Interest:</h4>
                                                Corporate Risk Management<br />
                                                Mergers and Acquisitions<br />
                                                Corporate Finance <br />
                                                Financial Modeling
                                            </Card.Text>
                                            <div className="book float-right">
                                                <GiTeacher />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            {/* <div className="faculty-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/unknown.png'} alt="faculty" />
                                            </div> */}
                                            <div className="course-pill">
                                                <FaHatCowboy />  Assistant Professor
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">Dr. Rubab Tahir</Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                                <h3>Qualification </h3>
                                                <p><b>Ph.D. (Management Science)</b><br />
                                                    Pir Mehar Ali Shah Arid Agriculture University Rawalpindi</p>
                                                <h4>Research Portfolio:</h4>
                                                Intellectual Capital Management<br />
                                                Educational Policy Analysis<br />
                                                AI augmented Business Process management<br />
                                                Human Resource Management<br />
                                                Sustainability<br />
                                                Knowledge & Innovation Management
                                            </Card.Text>
                                            <div className="book float-right">
                                                <GiTeacher />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            <div className="faculty-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/anumgul.jpeg'} alt="faculty" />
                                            </div>
                                            <div className="course-pill">
                                                <FaHatCowboy />  Lecturer
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">Anam Gul Kiyani </Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                                <h3>Qualification </h3>
                                                <p><b>MS (Finance)</b><br />
                                                Riphah international university </p>
                                                <h4>Research Portfolio:</h4>
                                                Corporate finance<br />
                                                Corporate governance
                                            </Card.Text>
                                            <div className="book float-right">
                                                <GiTeacher />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <Footer /> */}
            </>
        </m.div>
    )


}

export default FacultyManagementSciences